var styles = {"fontElementMap":"_6q8Wg","orderedlist":"OH8h9","bulletedlist":"Z22E5","listItem":"Z6-Kq"};

export { styles as s };
//# sourceMappingURL=lists-1e1565e1.js.map
